<app-header />

<app-breadcrumb />
<main class="content">
  <router-outlet />
</main>

<div class="footer">
  <pp-footer-bar [footerBarLinks]="footerBarLinks" />
</div>
